<script setup lang="ts">
const ratingsForm = reactive({
	stars: '',
	ratings: '',
	ratingsCount: '',
	url: '',
})

const { locale } = useI18n()
const pageTestimonialsSection = inject<Ref<ICMSLocationContent>>('pageTestimonialsSection')!
const sectionContent = ref<ICMSLocationContentTranslations>(
	pageTestimonialsSection.value?.translations.find((translation) => translation.language === locale.value)?.content,
)
const assignedLocations = inject<Ref<ILocationModel[]>>('assignedLocations')!

watch(
	() => assignedLocations.value,
	(v) => {
		if (v[0]) {
			if (v[0].countRatings && v[0].googleUrl && v[0].ratings) {
				ratingsForm.stars = v[0].ratings
				ratingsForm.ratings = v[0].ratings
				ratingsForm.ratingsCount = v[0].countRatings
				ratingsForm.url = v[0].googleUrl
			}
		}
	},
	{ deep: true, immediate: true },
)

const isAtleastOneTestimonialFilled = computed(() => {
	if (sectionContent.value && sectionContent.value?.length > 0) {
		return sectionContent.value.some((testimonial) => testimonial.text !== '' && testimonial.author !== '' && testimonial.stars !== '')
	}
	return false
})
</script>

<template>
	<section v-if="isAtleastOneTestimonialFilled" class="location-testimonials">
		<div class="location-testimonials__container">
			<GlobalImage class="location-testimonials__image" src="testimonials-image.png" alt="location-testimonials-image" />
			<div class="location-testimonials__image-shadow"></div>
			<h2
				data-aos="fade-up"
				class="location-testimonials__title"
				v-html="detectNewline($t('modules.home_page_module.testimonials.opinions'))"></h2>
			<Swiper
				class="location-testimonials__swiper"
				:slides-per-view="'auto'"
				:centered-slides="true"
				:loop="true"
				@after-init="
					(swiper) => {
						useTimeoutFn(() => {
							swiper.slideNext(0)
							swiper.slidePrev(0)
						}, 400)
					}
				">
				<SwiperSlide v-for="(slide, idx) in sectionContent" :key="idx" class="location-testimonials__swiper__slide">
					<TestimonialsItem data-aos="fade-up" :index="idx" :text="slide.text" :author="slide.author" :stars="slide.stars" />
				</SwiperSlide>
				<TestimonialsSwiperNav />
			</Swiper>
			<div class="location-testimonials__gradient location-testimonials__gradient--left"></div>
			<div class="location-testimonials__gradient location-testimonials__gradient--right"></div>
		</div>
		<div v-if="ratingsForm.stars && ratingsForm.stars !== ''" class="location-testimonials__google-review-wrapper">
			<div class="location-testimonials__google-review">
				<div class="location-testimonials__google-review-logo">
					<GlobalIcon name="google-icon" :height="16" />
				</div>
				<p data-aos="fade-up" class="location-testimonials__google-review-text">
					{{ $t('modules.home_page_module.testimonials.assessment') }} {{ ratingsForm.ratings }}
					{{ $t('modules.home_page_module.testimonials.of') }}
					<a :href="ratingsForm?.url" target="_blank" class="location-testimonials__google-review-link">
						{{ ratingsForm.ratingsCount }} {{ $t('modules.home_page_module.testimonials.opinions_1') }}
					</a>
					GOOGLE
				</p>
			</div>
		</div>
	</section>
</template>

<style lang="scss">
@import './Testimonials';
</style>
